module.exports = __webpack_public_path__ + "static/media/LogoCI.19483e15.png";